exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tips[data-v-035ed3b4]{font-size:12px;color:#9c9a9a}", ""]);

// exports
